module.exports = __webpack_public_path__ + "img/vendor-cand-rejected.7a497ac1.svg";